import { IProzessEventsWithAdditionalData } from "../pages/funktion/funktion.types";

export const verifyEventCategory = (prozessEvents: IProzessEventsWithAdditionalData[], category: string) =>
  prozessEvents.every(prozessEvent => prozessEvent.eventCategory === category);

export const filterProzessEventsByEventCategory = (
  prozessEvents: IProzessEventsWithAdditionalData[],
  category: string[]
) => prozessEvents.filter(item => category.includes(item.eventCategory));
